import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Hero.module.css';

function Hero() {
  return (
    <section className={styles.hero}>
      <h1>From Soil to Software</h1>
      <p className={styles.subtitle}>Building Digital Products That Solve Real Problems</p>
      <p className={styles.description}>
        Ragged Spade LLC creates practical mobile applications backed by years of product design experience.
        We build tools that work when you need them most—no fluff, just results.
      </p>
      <Link to="/#apps" className={styles.ctaButton}>Explore Our Apps</Link>
    </section>
  );
}

export default Hero;
